import { StepId } from "../adapaters/financialStatementMeta";

const FREQUENCIES = ["M", "W", "F", "4W", "Q", "A"];

const frequenciesKeys = {
    W: "Weekly",
    M: "Monthly",
    F: "Fortnightly",
    A: "Annually",
    "4W": "4-Weekly",
    Q: "Quarterly",
};

const stepOrder: StepId[] = ["about", "income", "fixed", "flexible", "debts"];

const sfsExpiredMessage = `It's important to keep your financial information up to date. We've noticed it's been over 6 months since you last completed 
    your Financial Statement. You can make changes to your existing statement by clicking change on the relevant area below.`;

const sfsUpToDateMessage = `If your Financial Statement details are up to date & your financial situation hasn't changed, you can proceed to create a payment 
    plan by clicking the "Save & continue" button below.`;

export { sfsExpiredMessage, sfsUpToDateMessage, stepOrder, FREQUENCIES, frequenciesKeys };
